<template lang="pug">
    .div
            crud-create-isapre(text="CREAR ISAPRE" :action="submitCreateIsapre" v-if="$can('CREATE_ISAPRE')")
            model-data-table(
                :no-actions="!$can('DELETE_ISAPRE')"
                no-detail
                no-search
                ref="refDataTable"
                remind-key='isapre-list'
                v-bind='tableProps'
                @detail="submitShow($event)"
                @remove="submitDeleteIsapre($event.item.id)"
            )
            dialog-create-isapre(ref="createIsapreRef" @success="refreshDT")
</template>

<script>
//-
import {
    CrudDataTable,
    DTService,
    CrudCreateButton,
} from '@/components/reusable_components'
import { mapActions, mapState } from 'vuex'
import IsapreTypeService from '@/services/api/isapreType/IsapreTypeServices'
import DialogCreateIsapreType from './partials/DialogCreateIsapreType'

import HeadersIsapreType from './IsapreTypeHeaders'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import IsapreTypeModel from '@/models/HumanResource/HrIsapreType'
//
import IsapreTypeFilters from './HrIsapreTypeFilters'
import IsapreTypeHeaders from './IsapreTypeHeaders'
//
export default {
    name: 'isapre-type-list',
    props: {},
    data: function() {
        return {
            service: {
                dtFetchData: () => {},
            },
            headers: HeadersIsapreType,
            filters: [],
            isapreTypeId: null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         * 
         */
        tableProps() {
            return {
                filters: IsapreTypeFilters,
                headers: IsapreTypeHeaders,
                service: IsapreTypeModel,
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        getIsapreTypes: function() {
            const url = process.env.VUE_APP_API_ROUTE.concat(`/hr_isapre_type`)
            this.service.dtFetchData = DTService.getFetchDataFunction(
                url,
                null,
                null,
                null
            )
        },
        submitCreateIsapre: function() {
            console.log('Crear nueva Isapre!')
            this.$refs.createIsapreRef.open = true
        },
        submitDeleteIsapre: function(event) {
            //-
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            //-
            let payload = this.fillSnack(
                'warning',
                '¿Desea Eliminar Isapre?',
                ''
            )
            this.initSnackbar(payload)
            //-
            this.isapreTypeId = event
        },
        refreshDT: function() {
            this.$refs.refDataTable.refresh()
        },
    },
    watch: {
        //- response de delete Isapre
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                //-
                this.resetSnackbarState()
                let response = await IsapreTypeService.deleteIsapreType(
                    this.isapreTypeId
                )
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Isapre eliminada exitosamente.',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDataTable.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-data-table': CrudDataTable,
        'crud-create-isapre': CrudCreateButton,
        'dialog-create-isapre': DialogCreateIsapreType,
        ModelDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount() {...},
    mounted: function() {
        this.setTitleTopBar('Lista de isapres')
        this.getIsapreTypes()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_ISAPRE')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>